import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { UnknownAction } from "redux";
import { ThunkDispatch } from "redux-thunk";

export type AppDispatch = ThunkDispatch<any, undefined, UnknownAction>;
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();

export const useTranslateText = (data: string) => {
  const { t } = useTranslation();
  const convertedValue = t(data ?? "");
  return convertedValue;
};

export const useTextConverter = () => {
  const { t } = useTranslation();
  const textConverter = (data: string) => {
    return t(data ?? "");
  };

  return textConverter;
};
